import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";

export interface RequestOptions extends AxiosRequestConfig {
  suppressNotFoundRedirect?: boolean;
  rejectOnError?: boolean;
}

class HTTPService {
  public static post(urn: string, data: object, options: RequestOptions = {}) {
    ApiService.events();
    return ApiService.httpRequest.post(urn, data, options);
  }

  public static patch(urn: string, data: object) {
    ApiService.events();
    return ApiService.httpRequest.patch(urn, data);
  }

  public static uploadFile(urn: string, data: object) {
    ApiService.events();
    return ApiService.httpRequest.post(urn, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  public static get(
    urn: string,
    paramsRequest = {},
    options: RequestOptions = {}
  ) {
    ApiService.events();
    return ApiService.httpRequest.get(urn, {
      ...options,
      params: paramsRequest,
    });
  }

  public static delete(urn: string, paramsRequest: object = {}) {
    ApiService.events();

    return ApiService.httpRequest.post(urn, {
      params: paramsRequest,
      _method: "delete",
    });
  }

  public static remove(urn: string, options: RequestOptions = {}) {
    ApiService.events();
    return ApiService.httpRequest.delete(urn, options);
  }

  public static isValid(response) {
    return response !== null && typeof response !== "undefined";
  }

  public static serverError() {
    return { 0: "Ошибка сервера, обратитесь в службу поддержки!" };
  }
}

export default HTTPService;
